import styled from 'styled-components'

import variables, { colors, device } from 'Styled/variables'

export const TargetInfoTiktok = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  padding: 48.5px 16px;
  background-color: ${colors.white};
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  @media ${device.mobileMin} {
    padding: 48.5px 24px;
  }
  @media ${device.smallScreen} {
    padding: 126px 16px;
  }
`

export const QuestionTitleText = styled.div`
  text-align: center;
  font-size: ${variables.fontSize20};
  color: ${colors.mainText};
  margin-bottom: 72px;
`

export const BtnWrapper = styled.div`
  min-width: 210px;
`
export const BtnWrapperLeft = styled.div`
  display: grid;
  min-width: 190px;
  margin-bottom: 16px;

  @media ${device.smallScreen} {
    margin-bottom: 0px;
    margin-right: 40px;
  }
`

export const QuestionWrapper = styled.div`
  margin: 0 auto;
  @media ${device.smallScreen} {
    display: flex;
    align-content: flex-start;
    justify-content: center;
    text-align: center;
    flex-direction: row;
  }
`
